import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '../assets/svg/logo-footer.svg'


const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer__content__left" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "footer__content__left__logo",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_4 = { class: "footer__content__left__text" }
const _hoisted_5 = { class: "footer__content__left__text" }
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]
const _hoisted_8 = ["href"]
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "footer__content__right" }
const _hoisted_11 = { class: "footer__content__right__links" }
const _hoisted_12 = ["href"]
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "footer__content__right__info" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "footer__content__right__info__address" }, [
  /*#__PURE__*/_createTextVNode(" DelayFix S.A. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ul. Ks. Ignacego Skorupki 5 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 00-546 Warszawa ")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "footer__content__right__info__company" }, " Sąd Rejonowy dla m. st. Warszawy w Warszawie, XII Wydział Gospodarczy Krajowego Rejestru Sądowego, KRS 742480, NIP 5213681825 ", -1)
const _hoisted_17 = { class: "footer__content__right__info__capital" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "footer__copyrights" }, " © 2024 DelayFix ", -1)

import { computed } from 'vue';
import ContentContainer from '@/layout/ContentContainer.vue'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

const { t } = useI18n() 
const store = useStore()



const langCode = computed(() => {
  return useI18n().locale
})

const contactDetails = computed(() => {
  return store.state.contactDetails
})

const termsLink = computed(() => {
  const links = {
    pl: 'https://delayfix.com/regulamin',
    en: 'https://delayfix.com/en/terms',
    cs: 'https://delayfix.com/cs/obchodni-podminky',
    sk: 'https://delayfix.com/sk/obchodne-podmienky',
  }

  const locale = useI18n().locale.value
  return links[locale] ?? links.pl
})

const privacyLink = computed(() => {
  const links = {
    pl: 'https://delayfix.com/polityka-prywatnosci',
    en: 'https://delayfix.com/en/privacy-policy',
    cs: 'https://delayfix.com/cs/zasady-ochrany-osobnich-udaju',
    sk: 'https://delayfix.com/sk/zasady-ochrany-osobnych-udajov',
  }

  const locale = useI18n().locale.value
  return links[locale] ?? links.pl
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createVNode(ContentContainer, { class: "footer__content" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)("footer.text")), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)("footer.contact")), 1),
          _createElementVNode("a", {
            href: 'tel:' + contactDetails.value['contact_phone_' + langCode.value.value],
            class: "footer__content__left__tel"
          }, _toDisplayString(contactDetails.value['contact_phone_' + langCode.value.value]), 9, _hoisted_6),
          _createElementVNode("a", {
            href: 'mailto:' + contactDetails.value['contact_email_' + langCode.value.value],
            class: "footer__content__left__mail"
          }, _toDisplayString(contactDetails.value['contact_email_' + langCode.value.value]), 9, _hoisted_7),
          (contactDetails.value['contact_email_2_' + langCode.value.value])
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: 'mailto:' + contactDetails.value['contact_email_2_' + langCode.value.value],
                class: "footer__content__left__mail"
              }, _toDisplayString(contactDetails.value['contact_email_2_' + langCode.value.value]), 9, _hoisted_8))
            : _createCommentVNode("", true),
          (contactDetails.value['contact_email_3_' + langCode.value.value])
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: 'mailto:' + contactDetails.value['contact_email_3_' + langCode.value.value],
                class: "footer__content__left__mail"
              }, _toDisplayString(contactDetails.value['contact_email_3_' + langCode.value.value]), 9, _hoisted_9))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("a", {
              href: termsLink.value,
              target: "_blank",
              class: "footer__content__right__links__item"
            }, _toDisplayString(_unref(t)("footer.terms")), 9, _hoisted_12),
            _createElementVNode("a", {
              href: privacyLink.value,
              class: "footer__content__right__links__item"
            }, _toDisplayString(_unref(t)("footer.privacy")), 9, _hoisted_13)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _hoisted_16,
            _createElementVNode("p", _hoisted_17, [
              _createTextVNode(_toDisplayString(_unref(t)("footer.capital")) + " ", 1),
              _hoisted_18,
              _createTextVNode(" 155 820,00 zł ")
            ])
          ])
        ]),
        _hoisted_19
      ]),
      _: 1
    })
  ]))
}
}

})